function post(path, params, method = 'post', target) {
	// const method = method || 'post'; // Set method to post by default if not specified.

	// The rest of this code assumes you are not using a library.
	// It can be made less wordy if you use one.
	const form = document.createElement('form');
	form.setAttribute('method', method);
	form.setAttribute('action', path);
	if (target) form.setAttribute('target', target); // Open in new tab

	Object.entries(params).forEach(([key, value]) => {
		const hiddenField = document.createElement('input');
		hiddenField.setAttribute('type', 'hidden');
		hiddenField.setAttribute('name', key);
		hiddenField.setAttribute('value', value);
		form.appendChild(hiddenField);
	});
	document.body.appendChild(form);
	form.submit();
}
/**
 * POST logic for redirection with payload
 * @param {string} path externalUrl
 * @param {object} params externalParameters
 * @param {string} [method] externalMethod
 */
function formRedirect(path, params, method, target = '_self') {
	console.log('form-redirect.js', path, params, method, target); //eslint-disable-line
	// https://www.google.se/search?q=klockan&oq=klockan&aqs=chrome..69i57j69i60l2j0l3.6000j0j4&sourceid=chrome&ie=UTF-8
	// https://www.google.se/search?
	// const test = {
	// 	q: 'klockan',
	// 	oq: 'klockan',
	// 	aqs: 'chrome..69i57j69i60l2j0l3.6000j0j4',
	// 	sourceid: 'chrome',
	// 	ie: 'UTF-8'
	// };
	// post('https://www.google.se/search', test, 'get');
	post(path, params, method, target);
}

function transformAndPost(form) {
	console.log('form-redirect.js', form); //eslint-disable-line
	const parser = new DOMParser();
	const formNode = parser.parseFromString(form, 'text/html');
	console.log(formNode.documentElement); //eslint-disable-line
	document.body.appendChild(formNode.documentElement);
	if (document.forms && document.forms.paymerosubmit) {
		document.forms.paymerosubmit.submit();
	}
}

export { transformAndPost };
export default formRedirect;
